export default function roomQuestionEventListener(room) {
  return store => {
    room.addEventListeners({
      // 질문 리스트 조회
      room_question_init: data => {
        store.commit('question/SET_QUESTION_LIST', data.data)
      },

      room_question_renew: data => {
        store.commit('question/SET_QUESTION_LIST', data.data)
      },
      room_inform_new_question: data => {
        store.commit('question/SET_QUESTION_ALERT', data.data)
      },
      room_question_change_status: data => {
        store.commit('question/SET_QUESTION', data.data)
      },

      // 질문 공개 여부 변경
      room_question_info_set: data => {
        store.commit('question/SET_QUESTION_INFO', data.data)
      },

      // 댓글 등록
      room_question_comment_set: data => {
        store.commit('question/SET_QUESTION_COMMENT', data.data);
      },

      // 댓글 삭제
      room_question_comment_delete: data => {
        store.commit('question/DELETE_QUESTION_COMMENT', data.data);
      },

      // 질문 좋아요
      room_question_like_set: data => {
        store.commit('question/SET_QUESTION_LIKE', data.data);
      },

      // 질문 좋아요 취소
      room_question_like_delete: data => {
        store.commit('question/DELETE_QUESTION_LIKE', data.data);
      }
    });
  }
}